import {
  ProjectStatus,
  ProjectStatusHistoryResponse,
} from "../../../api/services/project/model";
import { getFullName } from "../../../helpers/utils";

export const mapProjectStatusHistoryToTableData = (
  projectHistoryData: ProjectStatusHistoryResponse[],
): ProjectStatus[] => {
  return projectHistoryData.map((history) => ({
    id: history.createdModifiedBy.id,
    createdTimeStamp: history.createdModifiedDate,
    createdByName: getFullName(
      history.createdModifiedBy.firstName,
      history.createdModifiedBy.lastName,
      true,
    ),
    comment: history.comment,
    status: history.status,
  }));
};
